export default __webpack_public_path__ + "static/media/logo.6c58a34a.svg";